import { Controller, useFormContext } from "react-hook-form";
import { TiptapEditor } from "@circle-react-uikit/TipTap";
import type { TiptapEditorProps } from "@circle-react-uikit/TipTap/TiptapEditorProps.types";

export interface FormTipTapEditorProps extends TiptapEditorProps {
  name: string;
}

export const FormTipTapEditor = ({
  name,
  ...passThroughProps
}: FormTipTapEditorProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, value, onBlur },
      }: {
        field: {
          onChange: (value: any) => void;
          value: any;
          onBlur: () => void;
        };
      }) => (
        <TiptapEditor
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          {...passThroughProps}
        />
      )}
    />
  );
};
